import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import * as moment from 'moment';
import { DatePipe } from "@angular/common";
import Swal from "sweetalert2";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesDates } from '../../../models/messages';
import 'rxjs/add/observable/of';
import { FiltrosFondo } from 'app/models/FiltrosFondo';
import { DocumentoNegociableService } from 'app/services/documento-negociable/documento-negociable.service';
import { environment } from 'environments/environment';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

declare var $: any;
@Component({
  selector: 'app-listado-inversionistas',
  templateUrl: './listado-inversionistas.component.html',
  styleUrls: ['./listado-inversionistas.component.scss'],
  providers: [MessagesTitles, MessagesGeneral, MessagesDates,
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class ListadoInversionistasComponent implements OnInit {
  Label_id_soles=environment.ID_GUIA_SOLES;
  DTOFiltrosFondo: FiltrosFondo = new FiltrosFondo();
  loading: boolean;
  inversiones: any = [];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  pageSizeOptions = [15, 20, 30, 50, 100, 200];
  displayedColumns = ['idComprobante', 'Fecha_Registro', 'Codigo_de_Valor', 'RUT_Titular', 'VNPP_ICLV'];
  dataSource: any;

  constructor(private documentosNegociableService: DocumentoNegociableService, private datepipe: DatePipe) {
    this.DTOFiltrosFondo.FechaIni = this.datepipe.transform(moment().add(-320, 'day'), 'yyyy-MM-dd');
    this.DTOFiltrosFondo.FechaFin = this.datepipe.transform(moment(), 'yyyy-MM-dd');
  }

  ngOnInit() {
    this.ListadoFondoInversionistas();
  }

  ListadoFondoInversionistas() {
    this.loading = true;
    this.DTOFiltrosFondo.FechaIni = this.datepipe.transform(this.DTOFiltrosFondo.FechaIni, 'yyyy-MM-dd');
    this.DTOFiltrosFondo.FechaFin = this.datepipe.transform(this.DTOFiltrosFondo.FechaFin, 'yyyy-MM-dd');
    this.documentosNegociableService.ListarDocumentosNICLV(this.DTOFiltrosFondo)
      .subscribe(
        res => {
          this.inversiones = res;
          this.dataSource = new MatTableDataSource(this.inversiones);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          this.loading = false;
        }, err => {
          Swal.fire({
            title: "¡Algo salió mal!",
            text: err.error['error'],
            type: "warning",
            allowOutsideClick: true,
            heightAuto: false
          });
          this.loading = false;
        });
  }
}